import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AddNewDataModel} from '../model/add-new-data-model';
import {AddNewService} from '../service/add-new.service';
import {ResponseCode} from '../../../core/constant/response-code';

@Component({
  selector: 'app-add-refresh',
  templateUrl: './add-refresh.component.html',
  styleUrls: ['./add-refresh.component.css'],
})
export class AddRefreshComponent implements OnInit {
  @Input() addNewUrlName = '';
  @Input() isAddAllow = true;
  @Input() isRefreshAllow = true;
  @Input() isEditAllow = false;
  @Input() showHide = true;

  @Output('onRefreshList') onRefreshCallback: EventEmitter<void> = new EventEmitter<void>();

  submitted = false;
  private addNewUrl: string;

  addUpdate: string;
  public ngbRef: NgbModalRef;
  @Input() moduleName: string;

  constructor(private router: Router,
              private toaster: ToastrService,
              private ngbModalService: NgbModal,
              public service: AddNewService) { }

  ngOnInit() {
  }

  public onAddNew(addNew) {
    this.ngbRef =  this.ngbModalService.open(addNew, { windowClass: 'lg' , backdrop:'static'});
  }

  public onRefreshList() {
    this.onRefreshCallback.emit();
  }

  onSave(event: AddNewDataModel) {
    this.service.save(event, this.addNewUrlName).subscribe((response) => {
      if (response.responseCode !== ResponseCode.OK) {
        this.toaster.error(response.responseMessage, 'ERROR');
        return;
      }
      this.onSaveSuccess();
    },
    (error) => {
      this.onResponseError(error.message);
    });
  }

  public onSaveSuccess() {
    this.toaster.success('Data has been save successfully.', 'Success');
    this.onRefreshCallback.emit();
    this.dismiss();
  }

  private onResponseError(message: string) {
    this.toaster.error(message.replace('\n', '<br/>'), 'Error', {enableHtml: true});
  }

  dismiss() {
    this.ngbRef.close();
  }

  onAddUpdate() {
    this.addUpdate = (this.isAddAllow ? '/addUpdate' : '');
    this.router.navigate([]).then(open  => {
      window.open(this.addNewUrlName, '_blank');
    });
  }
}
